export const CONTRACT_STATUS_PAID = "PAID";
export const CONTRACT_STATUS_SUBMITTED = "SUBMITTED";
export const CONTRACT_STATUS_PAYOUTDONE = "PAYOUT_DONE";
export const CONTRACT_STATUS_CLOSED = "CLOSED";
